<template>
  <div>
    <v-btn block dark color="blue" @click="showCompose = true">
      <v-icon left>mdi-plus</v-icon>
      Compose
    </v-btn>
    <ComposeMail v-model="showCompose" />
  </div>
</template>

<script>
import ComposeMail from "./ComposeMail.vue"

export default {
  name: "ComposeButton",
  components: {
    ComposeMail,
  },
  data: () => ({
    showCompose: false,
  }),
}
</script>
